import { render, staticRenderFns } from "./MockExamLib.vue?vue&type=template&id=72490bb4&"
import script from "./mockExamLib.js?vue&type=script&lang=js&"
export * from "./mockExamLib.js?vue&type=script&lang=js&"
import style0 from "./mockExamLib.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports